import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { orgs } from '../lib/orgs';

import PageView from './PageView';
import { childrenPageViews } from './pages';

import config from '../lib/config';

const NOOP = () => <div />;

const mapStateToProps = (state) => {
  const {
    data = {},
    meta = {},
    filters = {},
    loading = false,
  } = state.page;
  const { type, payload = {}, query = {} } = state.location;
  const { orgId, toplevel = '', secondlevel = '' } = payload;
  const { error } = state.global;
  const ChildView = childrenPageViews[`${toplevel}/${secondlevel}`] || NOOP;
  const orgName = orgs.get(orgId || '').get('name', 'Unknown');
  const { menuItems = [] } = config;
  const toplevelMenuItem = _.find(menuItems, { type: toplevel.toLowerCase() }) || {};
  const menuItem = _.find(toplevelMenuItem.children || [], { type: secondlevel.toLowerCase() }) || {};
  const { user } = state.settings;
  const { dataQueries = {} } = state.dataQuery;

  return {
    type,
    payload,
    query,
    data,
    meta,
    filters,
    loading,
    orgId,
    orgName,
    toplevel,
    secondlevel,
    ChildView,
    menuItem,
    error,
    user,
    example: state.example,
    dataQueries,
  };
};

const mapDispatchToProps = dispatch => ({
  routeToOrg: (props) => {
    dispatch({ type: props.type, payload: props.payload, query: props.query });
  },
  routeToPage: (props) => {
    dispatch({ type: 'PAGE', ...props });
  },
  routeToLogin: () => {
    dispatch({ type: 'LOGIN', query: { logout: 'true' } });
  },
  dispatch: (...args) => {
    dispatch(...args);
  },
  applyFilter: (filterKey, filterObj) => {
    dispatch({ type: 'PAGE_FILTER', filterKey, filterObj });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PageView);



// WEBPACK FOOTER //
// ./src/views/PageContainer.js